import { useNavigate, useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "./sharedInterface";
import { useEffect } from "react";
import {
  mileageGapReportFileExportAsync,
  monthlyMileageGapReportsListByUserAsync,
  planningMonthlyRowsAsync,
  selectMonthlyReportsListStatus,
  selectPlanningMonthlyRowsStatus,
} from "../fleetSlice";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany, selectManager } from "../../homeSlice";

export type MonthlyReportsTabProps = {
  canGenerateReports: boolean;
};

export const MonthlyReportsTab = ({
  canGenerateReports,
}: MonthlyReportsTabProps) => {
  const params = useParams();
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1];
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const manager = useAppSelector(selectManager);
  const monthlyReportsListStatus = useAppSelector(
    selectMonthlyReportsListStatus,
  );
  const planningMonthlyRowsStatus = useAppSelector(
    selectPlanningMonthlyRowsStatus,
  );

  const handleDownloadReportFile = (reportFileUuid: string) => {
    void dispatch(mileageGapReportFileExportAsync(reportFileUuid));
  };

  useEffect(() => {
    if (company && manager && monthlyReportsListStatus === "idle") {
      void dispatch(monthlyMileageGapReportsListByUserAsync(manager.uuid));
    }
  }, [dispatch, manager, monthlyReportsListStatus, company]);

  useEffect(() => {
    if (company && planningMonthlyRowsStatus === "idle") {
      void dispatch(planningMonthlyRowsAsync(company.uuid));
    }
  }, [company, dispatch, planningMonthlyRowsStatus]);

  useEffect(() => {
    if (
      params.tab === "monthly_reports" &&
      company &&
      !company.hasAdvancedAnalytics
    ) {
      navigate(`/${firstPath}`);
    }
  }, [params.tab, company, navigate, firstPath]);

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <SharedInterfaceMonthlyReports
      canGenerateReports={canGenerateReports}
      downloadReportFileAction={handleDownloadReportFile}
    />
  );
};
